import { createStyles, rem } from "@mantine/core"

export const useStyles = createStyles(
    (theme, { columnWidth, isAboveBreackpoint }: { columnWidth: string; isAboveBreackpoint: boolean }) => ({
        columns: {
            width: "100%",
            display: "flex",
            alignItems: "stretch",
            justifyContent: "flex-start",
            flexWrap: "nowrap",
            flexDirection: "row",
            gap: "inherit",
        },
        leftColumn: {
            display: "flex",
            gap: "inherit",
            width: "50%",
        },
        divider: {
            width: rem(1),
            backgroundColor: theme.colors.gray[2],
        },
        singleColumn: {
            gap: "inherit",
            width: isAboveBreackpoint ? columnWidth : "100%",
        },
    }),
)
